import padZeroEnd from './utils/padZeroEnd';
import separateThousands from './utils/separateThousands';

/**
 * Converts user input to the Dutch formatted version of number.
 *
 * @param value
 * @param [decimalCount] by default leaves the decimals part unchanged.
 * Passing in the decimals will either trim or pad the decimals part of the number being formatted
 * @returns {*}
 */
export default function getFormattedNumber(value: any, decimalCount: number = -1): string {
  const split = String(value).split('.');
  let digits = split[0];
  const decimals = padZeroEnd(split[1] || '', decimalCount);

  digits = digits.replace(/[^\d-]/g, '').replace(/^([-]?)\./, '$1');

  return separateThousands(digits) + (decimals.length > 0 ? `,${decimals}` : '');
}
